import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  
  constructor() { }
  
}



// WEBPACK FOOTER //
// /home/shane/workspace/website/website-client/src/app/app.component.ts